import FlameLogo from "./FlameLogo";
import { openCookieSettings } from "../lib/cookie-consent";

const legal = [
  { label: "Privacy", href: "/privacy-policy" },
  { label: "Terms", href: "/terms" },
  { label: "Cookies", href: "/cookies-policy" },
];

const socials = [
  { label: "GitHub", href: "https://github.com/Bigbrotha12" },
  { label: "LinkedIn", href: "https://linkedin.com/in/rafaelmendoza64" },
  { label: "X", href: "https://x.com/RafaelM27764900" },
  { label: "Telegram", href: "https://t.me/bigbrotha1" },
  { label: "Email", href: "mailto:contact@fire-chain.com" },
];

export default function Footer() {
  return (
    <footer className="t-footer">
      <div className="t-wrap">
        <div className="t-footer__top">
          <div>
            <a href="#main-content" className="t-wordmark">
              <FlameLogo />
              <span>Firechain</span>
            </a>
            <p className="t-footer__name">
              Finance automation for accounting firms. Fixed scope, fixed price.
            </p>
          </div>

          <div className="t-footer__cols">
            <div className="t-footer__col">
              <h3>Elsewhere</h3>
              <nav className="t-footer__links" aria-label="Elsewhere">
                {socials.map((social) => (
                  <a key={social.label} href={social.href} target="_blank" rel="noreferrer">
                    {social.label}
                  </a>
                ))}
              </nav>
            </div>

            <div className="t-footer__col">
              <h3>Legal</h3>
              <nav className="t-footer__links" aria-label="Legal">
                {legal.map((item) => (
                  <a key={item.label} href={item.href}>
                    {item.label}
                  </a>
                ))}
                <button type="button" onClick={openCookieSettings}>
                  Cookie settings
                </button>
              </nav>
            </div>
          </div>
        </div>

        <div className="t-footer__bottom">
          <span>&copy; {new Date().getFullYear()} Firechain Services LLC.</span>
          <span>
            Pictures:{" "}
            <a href="https://commons.wikimedia.org/wiki/File:Account-book_of_Thomas_Mister_Wellcome_L0050229.jpg">
              Account-book of Thomas Mister
            </a>{" "}
            by Wellcome Library, London,{" "}
            <a href="https://creativecommons.org/licenses/by/4.0/">CC BY 4.0</a>;{" "}
            <a href="https://commons.wikimedia.org/wiki/File:Code_on_computer_monitor_(Unsplash).jpg">
              Code on computer monitor
            </a>{" "}
            by Markus Spiske, <a href="https://creativecommons.org/publicdomain/zero/1.0/">CC0</a> —
            all via Wikimedia Commons.
          </span>
        </div>
      </div>
    </footer>
  );
}
